import { IApp } from '@/types/nuxt'
import { VisaTypeGetters } from '@tokyojob/core'
import { IFormInputData, IFormInputDataUsecase, LogType } from '@tokyojob/frontend-core'

export default class VisaTypeGetUsecase implements IFormInputDataUsecase {
  /**
   * @param app IApp instance used to access the Gateway and Log services.
   */
  constructor(private readonly app: IApp) {}

  /**
   * Attempts to fetch the possible vacancy locations from the API based on the passed text string.
   * @param text The current text that is in the input field.
   */
  async execute(): Promise<IFormInputData[]> {
    const { baseGateway, logService } = this.app
    try {
      const res = await baseGateway.common.FetchAllVisaTypes()
      if (!res) throw new Error()
      return res.map((e) => {
        return { label: VisaTypeGetters.getName(e), value: e.id }
      })
    } catch (error) {
      await logService.handle({ type: LogType.Error, error: error as Error })
      return []
    }
  }
}
